import { render } from "./SportMvb.vue?vue&type=template&id=b38948e4"
import script from "./SportMvb.vue?vue&type=script&lang=js"
export * from "./SportMvb.vue?vue&type=script&lang=js"
script.render = render

export default script